__turbopack_context__.v({
  "blok-big-title": "Cart-module__uN3DQa__blok-big-title",
  "blok-subtitle": "Cart-module__uN3DQa__blok-subtitle",
  "blok-title": "Cart-module__uN3DQa__blok-title",
  "buttons": "Cart-module__uN3DQa__buttons",
  "cart-content": "Cart-module__uN3DQa__cart-content",
  "cart-dialog": "Cart-module__uN3DQa__cart-dialog",
  "cart-empty": "Cart-module__uN3DQa__cart-empty",
  "cart-header": "Cart-module__uN3DQa__cart-header",
  "cart-modal": "Cart-module__uN3DQa__cart-modal",
  "cart__text__desktop": "Cart-module__uN3DQa__cart__text__desktop",
  "cart__text__mobile": "Cart-module__uN3DQa__cart__text__mobile",
  "close-button": "Cart-module__uN3DQa__close-button",
  "mobile__cart__indicator": "Cart-module__uN3DQa__mobile__cart__indicator",
  "title": "Cart-module__uN3DQa__title",
});
